import { useState, useEffect } from "react";
import { LOGO_URL, TELEGRAM_URL } from "../lib/config";
import { Button } from "./ui/button";
import { Send, Menu, X } from "lucide-react";

const links = [
    { label: "Menu", href: "#menu" },
    { label: "Delivery", href: "#delivery" },
    { label: "Contact", href: "#contact" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "glass border-b border-white/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <a
                    data-testid="header-logo"
                    href="/"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={LOGO_URL}
                        alt="High 95"
                        className="w-10 h-10 rounded-xl object-cover ring-1 ring-white/10 group-hover:ring-highway-red/60 transition bg-white/5"
                    />
                    <div className="leading-none">
                        <p className="font-display font-bold text-white text-lg tracking-tight">
                            HIGH95
                        </p>
                        <p className="font-mono text-[10px] text-white/50 uppercase tracking-widest mt-0.5">
                            Exit · NJ
                        </p>
                    </div>
                </a>

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            data-testid={`nav-${l.label.toLowerCase()}`}
                            key={l.href}
                            href={l.href}
                            className="text-sm font-medium text-white/70 hover:text-white transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <Button
                        data-testid="header-telegram-btn"
                        asChild
                        className="rounded-full bg-highway-telegram hover:bg-highway-telegram/90 text-white font-semibold px-5 transition-transform hover:-translate-y-0.5"
                    >
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Send className="w-4 h-4 mr-2" />
                            Order on Telegram
                        </a>
                    </Button>
                </div>

                <button
                    data-testid="mobile-menu-btn"
                    onClick={() => setOpen(!open)}
                    className="md:hidden text-white p-2"
                    aria-label="menu"
                >
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden glass border-t border-white/10 px-4 py-6 space-y-4"
                >
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            className="block text-white/80 hover:text-white text-base font-medium"
                        >
                            {l.label}
                        </a>
                    ))}
                    <Button
                        asChild
                        className="w-full rounded-full bg-highway-telegram hover:bg-highway-telegram/90 text-white font-semibold"
                    >
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Send className="w-4 h-4 mr-2" />
                            Order on Telegram
                        </a>
                    </Button>
                </div>
            )}
        </header>
    );
}
